// src/plugins/vuetify.js
import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

import he from "vuetify/es5/locale/he";

Vue.use(Vuetify);
const myTheme = {
  dark: false,
  colors: {}
};
export default new Vuetify({
  theme: {
    themes: {
      light: {
        main_pink: '#f03573',
        secondary: '#ff9c00',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },

  },
  icons: {
    iconfont: "mdi",
  },
  lang: {
    locales: { he },
    current: "he",
  },
  rtl: true,

});
